<template>
  <div>
    <b-row>
      <b-col class="d-flex justify-content-between pb-1 align-items-center">
        <h1 class="font-weight-bolder">
          {{ $t('overduePayments') }}
        </h1>
      </b-col>
    </b-row>

    <b-row v-if="quotes.length > 0">
      <b-col>
        <b-overlay :show="loading">
          <quotes-table
            :quotes="quotes"
            no-tools
            show-purchased-date
            show-days-overdue
            @refetch="handleFetchQuotes($event)"
          />
        </b-overlay>
      </b-col>
      <b-col sm="12">
        <b-row>
          <b-col class="d-flex justify-content-end">
            <b-pagination
              :value="quotesPagination.page"
              :total-rows="quotesPagination.total_objects"
              :per-page="quotesPagination.per_page"
              aria-controls="my-table"
              @change="nextPage($event)"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row v-if="quotes.length === 0">
      <b-col>
        <h4 class="display-4">
          No hay cotizaciones a crédito vencidas 💸
        </h4>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import QuotesTable from '@/components/purchaseOrders/PurchaseOrdersViewTable.vue'

export default {
  name: 'OverduePayments',
  components: {
    QuotesTable,
  },
  data() {
    return {
      loading: false,
      sortBy: null,
      sortDesc: null,
    }
  },
  computed: {
    ...mapGetters('quotes', ['quotes', 'quotesPagination']),
  },
  created() {
    this.handleFetchQuotes()
  },
  methods: {
    ...mapMutations('quotes', {
      clearQuotes: 'CLEAR_QUOTES',
      changePagination: 'CHANGE_PAGINATION',
    }),

    ...mapActions('quotes', ['fetchQuotes']),

    nextPage(value) {
      this.changePagination({ field: 'page', value })
      this.handleFetchQuotes({
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        pagination: {
          ...this.quotesPagination,
          page: value,
        },
      })
    },

    handleFetchQuotes({ sortBy, sortDesc, pagination } = {}) {
      if (sortBy !== undefined) this.sortBy = sortBy
      if (sortDesc !== undefined) this.sortDesc = sortDesc

      const meta = {
        pagination: pagination || this.quotesPagination,
      }

      if (this.sortBy && this.sortDesc !== null) {
        meta.sort = `${this.sortBy}:${this.sortDesc ? 'desc' : 'asc'}`
      }

      const params = {
        by_is_credit: true,
        by_payment_status: 'credit_approved',
        meta,
      }

      if (this.sortBy && this.sortDesc !== null) {
        params.sort = `${this.sortBy}:${this.sortDesc ? 'desc' : 'asc'}`
      }

      this.loading = true
      this.fetchQuotes(params).finally(() => {
        this.loading = false
      })
    },
  },
}
</script>
